import { useState } from "react";

// Configure only the approved, price-free sales letter. Demo/checkout clips may
// contain prices and must not be substituted for this asset.
export const PRICE_INTRO_VIDEO = import.meta.env.VITE_BLISS_PRICE_VSL_URL || "";

export default function BlissPriceIntroduction({
  onContinue,
  videoSrc = PRICE_INTRO_VIDEO,
}: {
  onContinue: () => void;
  videoSrc?: string;
}) {
  const [videoFailed, setVideoFailed] = useState(false);
  return (
    <section className="bcj-price-introduction" aria-label="Before your price">
      {videoSrc && !videoFailed && (
        <video
          controls
          playsInline
          preload="metadata"
          aria-label="Your Bliss room introduction"
          onError={() => setVideoFailed(true)}
        >
          <source src={videoSrc} />
        </video>
      )}
      {videoFailed && (
        <p role="status">
          The video couldn’t load. You can still continue to your price.
        </p>
      )}
      <div className="bcj-letter">
        <h2>A room worth coming together for.</h2>
        <p>
          Your preview is a starting point. We’ll confirm your room
          measurements, layout and selected details before production.
        </p>
        <p>
          Next, you’ll see the price for your selections and the available ways
          to move forward.
        </p>
      </div>
      <button type="button" className="bcj-primary" onClick={onContinue}>
        Reveal My Price
      </button>
    </section>
  );
}
